import { TEST_ID_PLAYER_ROSTER } from "e2e/testId";
import { CheckIcon } from "lucide-react-native";
import React, { memo } from "react";

import {
  Checkbox,
  CheckboxGroup,
  CheckboxIcon,
  CheckboxIndicator,
} from "@/components/atoms/Checkbox";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";
import { RosterManagementLeagueFragment } from "@/generated/graphql";

/**
 *
 */
interface Props {
  item: RosterManagementLeagueFragment;
  hasSelectedLeague: boolean;
  isSmallScreen: boolean;
  onChange: (leagueIds: string[]) => void;
}

/**
 * View for displaying a league item with checkbox selection.
 * @param root0 - Component props
 * @param root0.item - League data to display
 * @param root0.hasSelectedLeague - Whether this league is selected for the organization
 * @param root0.isSmallScreen - Whether to use mobile layout styling
 * @param root0.onChange - Callback when league selection changes with league IDs
 */
const LeagueItemView = ({
  item,
  hasSelectedLeague,
  isSmallScreen,
  onChange,
}: Props) => (
  <Stack
    direction="horizontal"
    className={`items-center justify-between gap-3 ${!isSmallScreen ? "px-4 py-3" : "py-2"}`}
  >
    <Text
      variant={!isSmallScreen ? "title-lg" : "display-sm"}
      className="shrink"
    >
      {item.name}
    </Text>
    <CheckboxGroup
      testID={
        hasSelectedLeague
          ? TEST_ID_PLAYER_ROSTER.LEAGUE_SELECTION_CHECKBOX_CHECKED
          : TEST_ID_PLAYER_ROSTER.LEAGUE_SELECTION_CHECKBOX_UNCHECKED
      }
      aria-label="checkbox group"
      onChange={onChange}
      value={hasSelectedLeague ? [item.id] : []}
    >
      <Checkbox aria-label={`${item.name} checkbox`} value={item.id}>
        <CheckboxIndicator>
          <CheckboxIcon
            as={CheckIcon}
            className="border-none bg-status-info text-content-on-accent"
            {...(!isSmallScreen ? { size: "md" } : {})}
          />
        </CheckboxIndicator>
      </Checkbox>
    </CheckboxGroup>
  </Stack>
);

LeagueItemView.displayName = "LeagueItemView";

export default memo(LeagueItemView);
